//Para producción:

/*const URL = 'https://backaoc.ibero.mx/';
export const baseURL = URL;
*/
//Fin Producción.

//Para pruebas en Jocoque:

const URL = ' https://aocibero.gtsf.com.mx/';
export const baseURL = URL;

//Fin pruebas en Jocoque.

//Para pruebas locales:
/*
const URL = 'http://172.16.1.89';
export const baseURL = URL + ':9539';
export const docsURL = URL;
*/
//Fin pruebas locales
